import React from 'react';
import { Timer } from './Timer';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-brand-jet border-t border-brand-gold/15 relative overflow-hidden" data-id="element-108">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-109"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-110">
        <Timer data-id="element-111" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12 mb-12 relative z-10" data-id="element-112">
          {/* Basic */}
          <motion.a href="https://www.impulsodigitalstore.com/cart/43016137179213:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-ink/80 border border-brand-gold/40 py-6 px-6 rounded-2xl flex flex-col items-center justify-center gap-2 hover:border-brand-gold/80 transition-all" style={{
          boxShadow: '0 20px 50px -20px rgba(0,0,0,0.7), inset 0 1px 0 rgba(212,168,67,0.1)'
        }} data-id="element-113">
            <span className="text-base sm:text-lg font-extrabold text-brand-cream flex items-center gap-2 text-center" data-id="element-114">
              📦 MEGAPACK COCINA SIN GLUTEN Y SIN AZÚCAR™
            </span>
            <div className="flex items-center gap-3" data-id="element-115">
              <span className="line-through text-brand-cream/40 text-sm" data-id="element-116">
                $51.000
              </span>
              <span className="font-display font-black text-2xl text-brand-gold glow-gold" data-id="element-117">
                → $19.990 ARS
              </span>
            </div>
            <span className="mt-2 bg-brand-gold text-brand-base px-5 py-2 rounded-full text-sm font-extrabold uppercase tracking-wider shadow-md" data-id="element-118">
              ✦ QUIERO MI MEGAPACK ✦
            </span>
          </motion.a>

          {/* Premium */}
          <motion.a href="https://www.impulsodigitalstore.com/cart/43016137965645:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full py-6 px-6 rounded-2xl flex flex-col items-center justify-center gap-2 border-2 border-brand-gold relative transition-colors" style={{
          background: '#141414'
        }} data-id="element-119">
            <div className="absolute -top-4 bg-brand-gold text-brand-base px-4 py-1 rounded-full text-xs font-black uppercase tracking-widest shadow-sm" data-id="element-120">
              ⭐ MÁS POPULAR
            </div>
            <span className="text-base sm:text-lg font-extrabold text-brand-gold flex items-center gap-2 text-center mt-1" data-id="element-121">
              👑 MEGAPACK + MASTERCLASS PAN DE CAMPO Y MASA MADRE™
            </span>
            <div className="flex items-center gap-3" data-id="element-122">
              <span className="line-through text-brand-cream/40 text-sm" data-id="element-123">
                $69.000
              </span>
              <span className="font-display font-black text-2xl text-brand-gold glow-gold" data-id="element-124">
                → $27.990 ARS
              </span>
            </div>
            <span className="mt-2 bg-brand-gold text-brand-base px-5 py-2 rounded-full text-sm font-extrabold uppercase tracking-wider shadow-md" data-id="element-125">
              👑 QUIERO EL PACK COMPLETO
            </span>
          </motion.a>
        </div>

        <div className="bg-brand-ink/70 backdrop-blur-sm py-4 sm:py-6 px-2 rounded-2xl border border-brand-gold/25 overflow-x-auto" data-id="element-126">
          <div className="flex flex-nowrap justify-center items-center gap-x-3 sm:gap-x-8 text-[10px] sm:text-sm font-bold text-brand-cream/80 whitespace-nowrap" data-id="element-127">
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-128">
              <Lock className="text-brand-gold shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-129" />{' '}
              Pago 100% seguro
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-130">
              <Zap className="text-brand-gold shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-131" />{' '}
              Acceso en 5 min
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-132">
              <Shield className="text-brand-gold shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-133" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-1 sm:gap-2 whitespace-nowrap" data-id="element-134">
              <CreditCard className="text-brand-gold shrink-0 w-3.5 h-3.5 sm:w-[18px] sm:h-[18px]" data-id="element-135" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </div>
    </section>;
}